export enum WidgetDataTypesEnum {
    Sensor = 'sensor',
    API = 'api'
}
